<template>
  <router-link to="/">
    <img
      class="img-fluid for-light"
      src="../../assets/images/logo/mexico_verde2.png"
      alt="Portal México Verde"
      id="logo_klatus"
    /><img
      class="img-fluid for-dark"
      src="../../assets/images/logo/mexico_verde2.png"
      alt="Portal México Verde"
    />
  </router-link>
</template>

<script>

  export default {
    name: 'Logo',
  };
</script>

<style scoped>
  #logo_klatus {
    width:100% !important;
  }
</style>
